export enum MagicTextTypeEnum {
  Rewrite = 1,
  Shorten = 2,
  Revise = 3,
  Transcript = 4,
}
